import { Config } from '../../../config.ts'

const config = Config()
const { api2Endpoint, companionEndpoint } = config

export const api2 = () => api2Endpoint
export const companion = () => companionEndpoint
